import { useCallback } from "react";
import {
    getStoredToken,
    login as loginService,
    logout as logoutService,
} from "../services/auth.service";
import { useGlobalContext } from "../context/useGlobalContext";

export default function useAuth() {
    const { resetGlobalState } = useGlobalContext();

    const login = useCallback(async (data) => {
        resetGlobalState();
        const session = await loginService(data);
        return {
            token: session.token,
            user: session.user,
            ...session.raw,
        };
    }, [resetGlobalState]);

    const logout = useCallback(() => {
        logoutService();
        resetGlobalState();
        window.location.href = "/login";
    }, [resetGlobalState]);

    const isAuthenticated = useCallback(() => Boolean(getStoredToken()), []);

    return {
        login,
        logout,
        isAuthenticated,
    };
}
